// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + {"2007":"2106ede95e6119e2b9a8","4537":"7280d5b6a19c857c3dc2","9152":"e6a90102488bf8bd6ba1"}[chunkId] + "";
};